// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jiAv4","importantInfo":"styles_importantInfo__1pT27"};